export enum FundType {
  ACH = 'ACH',
  WIRE = 'WIRE',
  CHECK = 'CHECK',
  CREDITCARD = 'CREDITCARD',
}
